import React from 'react'

export default function ServiceUnavailable({errors}) {
  return (
    <div className="ds-banner -danger">
      <small className="preamble"> Notice </small>
      <p className="copy"> Lost internet connection, Trying to reconnect... </p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/ServiceUnavailable.js